<template>
  <div id="app">
    <div class="card border-primary" style="margin-bottom: 20px">
      <div class="card-header">
        <h5 style="margin-bottom: 0px">BetRadar Soccer Scores</h5>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="col">
            <div class="form-group">
              <label>Competition</label>
              <select @change="selectCompetition" class="form-control">
                <option value="">-- Select --</option>
                <option
                  v-for="competition in competitions"
                  :value="competition.id"
                  :key="competition.id"
                >
                  {{ competition.name }} - {{ competition.category.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label>Season year</label>
              <select @change="selectSeasonYear" class="form-control">
                <option value="">-- Select --</option>
                <option
                  v-for="seasonYear in seasonYears"
                  :value="seasonYear.id"
                  :key="seasonYear.id"
                >
                  {{ seasonYear.year }}
                </option>
              </select>
            </div>
          </div>
          <div class="col">
            <div class="form-group" v-if="sportEvents">
              <label>Game</label>
              <select @change="selectSportEvent" class="form-control">
                <option value="">-- Select --</option>
                <option
                  v-for="sportEvent in sportEvents"
                  :value="sportEvent.sport_event.id"
                  :key="sportEvent.sport_event.id"
                >
                  {{ getSportEventName(sportEvent) }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div>
          <p>These are the BetRadar endpoints used to build this page.</p>
          <table class="table" style="text-align: left">
            <tr>
              <td>Competitions</td>
              <td>
                <a :href="getCompetitionEndpoint(true)" target="_blank">{{
                  getCompetitionEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="competitionId">
              <td>Competition Seasons</td>
              <td>
                <a :href="getCompetitionSeasonEndpoint(true)" target="_blank">{{
                  getCompetitionSeasonEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="seasonYearId">
              <td>Season Schedule</td>
              <td>
                <a :href="getSeasoScheduleEndpoint(true)" target="_blank">{{
                  getSeasoScheduleEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="sportEventId">
              <td>Sport Event Timeline</td>
              <td>
                <a
                  :href="getSportEventTimelineEndpoint(true)"
                  target="_blank"
                  >{{ getSportEventTimelineEndpoint(true) }}</a
                >
              </td>
            </tr>
            <tr v-if="sportEventId">
              <td>Sport Event Lineups</td>
              <td>
                <a :href="getSportEventLineupsEndpoint(true)" target="_blank">{{
                  getSportEventLineupsEndpoint(true)
                }}</a>
              </td>
            </tr>
            <tr v-if="competitorId1 && competitorId2">
              <td>Competitor vs Competitor</td>
              <td>
                <a
                  :href="getCompetitorVsCompetitorEndpoint(true)"
                  target="_blank"
                  >{{ getCompetitorVsCompetitorEndpoint(true) }}</a
                >
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>

    <div v-if="sportEventId">
      <div id="accordion">
        <div class="card" v-if="sportEvent && sportEvent.sport_event_context">
          <div class="card-header" id="headingOne">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Game
              </button>
            </h5>
          </div>

          <div
            id="collapseOne"
            class="collapse show"
            aria-labelledby="headingOne"
          >
            <div class="card-body">
              <table class="table">
                <tr>
                  <th>scheduled</th>
                  <th>id</th>
                  <th>tournament</th>
                  <th>tournament_round</th>
                  <th>venue</th>
                </tr>
                <tr>
                  <td>
                    {{ sportEvent.start_time }}
                    <br />
                    start_time_confirmed: {{ sportEvent.start_time_confirmed }}
                  </td>
                  <td>
                    {{ sportEvent.id }}
                  </td>
                  <td>
                    {{ sportEvent.sport_event_context.competition.name }}
                    <br />
                    category id: {{ sportEvent.sport_event_context.category.id
                    }}<br />
                    category name:
                    {{ sportEvent.sport_event_context.category.name }}
                  </td>
                  <td>
                    number: {{ sportEvent.sport_event_context.round.number
                    }}<br />
                    phase: {{ sportEvent.sport_event_context.stage.phase
                    }}<br />
                    type: {{ sportEvent.sport_event_context.stage.type }}<br />
                  </td>
                  <td>
                    name: {{ sportEvent.venue.name }}<br />
                    id: {{ sportEvent.venue.id }}<br />
                    capacity: {{ sportEvent.venue.capacity }}<br />
                    city_name: {{ sportEvent.venue.city_name }}<br />
                    country_code: {{ sportEvent.venue.country_code }}<br />
                    country_name: {{ sportEvent.venue.country_name }}<br />
                    map_coordinates: {{ sportEvent.venue.map_coordinates }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>

        <div class="card" v-if="sportEvent && sportEvent.competitors">
          <div class="card-header" id="heading1">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                data-toggle="collapse"
                data-target="#collapse1"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Competitors
              </button>
            </h5>
          </div>

          <div id="collapse1" class="collapse show" aria-labelledby="heading1">
            <div class="card-body">
              <SoccerScoresCompetitors
                :competitors="sportEvent.competitors"
              ></SoccerScoresCompetitors>
            </div>
          </div>
        </div>

        <div class="card" v-if="sport_event_status">
          <div class="card-header" id="headingOne">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                data-toggle="collapse"
                data-target="#collapse3"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Status
              </button>
            </h5>
          </div>

          <div
            id="collapse3"
            class="collapse show"
            aria-labelledby="headingOne"
          >
            <div class="card-body">
              <SoccerScoresMatchStatus
                :sport_event_status="sport_event_status"
              ></SoccerScoresMatchStatus>
            </div>
          </div>
        </div>

        <div class="card" v-if="statistics">
          <div class="card-header" id="heading2">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                data-toggle="collapse"
                data-target="#collapse4"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Statistics
              </button>
            </h5>
          </div>

          <div id="collapse4" class="collapse show" aria-labelledby="heading2">
            <div class="card-body">
              <SoccerScoresMatchStatistics
                :statistics="statistics"
              ></SoccerScoresMatchStatistics>
            </div>
          </div>
        </div>

        <div class="card" v-if="timeline">
          <div class="card-header" id="headingOne">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                data-toggle="collapse"
                data-target="#collapse5"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Timeline
              </button>
            </h5>
          </div>

          <div
            id="collapse5"
            class="collapse show"
            aria-labelledby="headingOne"
          >
            <div class="card-body">
              <SoccerScoresMatchTimeline
                :timeline="timeline"
              ></SoccerScoresMatchTimeline>
            </div>
          </div>
        </div>

        <div class="card" v-if="lineups">
          <div class="card-header" id="headingOne">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                data-toggle="collapse"
                data-target="#collapse6"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Lineups
              </button>
            </h5>
          </div>

          <div
            id="collapse6"
            class="collapse show"
            aria-labelledby="headingOne"
          >
            <div class="card-body">
              <SoccerScoresLineups :lineups="lineups"></SoccerScoresLineups>
            </div>
          </div>
        </div>

        <div class="card" v-if="competitorVsCompetitor.last_meetings">
          <div class="card-header" id="headingOne">
            <h5 class="mb-0">
              <button
                class="btn btn-link"
                data-toggle="collapse"
                data-target="#collapseCompetitorVsCompetitor"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Competitor versus Competitor
              </button>
            </h5>
          </div>

          <div
            id="collapseCompetitorVsCompetitor"
            class="collapse show"
            aria-labelledby="headingOne"
          >
            <div class="card-body">
              <table class="table" v-if="competitorVsCompetitor.last_meetings">
                <tr>
                  <th>season</th>
                  <th>competitors</th>
                  <th>status</th>
                </tr>
                <tr
                  v-for="meeting in competitorVsCompetitor.last_meetings"
                  :key="meeting.id"
                >
                  <td>
                    <span v-if="meeting.sport_event.sport_event_context.season"
                      >{{ meeting.sport_event.sport_event_context.season.name
                      }}<br
                    /></span>
                    {{ meeting.sport_event.start_time }}
                  </td>
                  <td>
                    {{ meeting.sport_event.competitors[0].name }}
                    {{ meeting.sport_event.competitors[0].qualifier }}<br />
                    {{ meeting.sport_event.competitors[1].name }}
                    {{ meeting.sport_event.competitors[1].qualifier }}<br />
                  </td>
                  <td>
                    away_score: {{ meeting.sport_event_status.away_score
                    }}<br />
                    home_score: {{ meeting.sport_event_status.home_score
                    }}<br />
                    match_status: {{ meeting.sport_event_status.match_status
                    }}<br />
                    winner_id: {{ meeting.sport_event_status.winner_id }}<br />
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoccerScoresCompetitors from "./components/SoccerScoresCompetitors.vue";
import SoccerScoresConditions from "./components/SoccerScoresConditions.vue";
import SoccerScoresMatchStatus from "./components/SoccerScoresMatchStatus.vue";
import SoccerScoresMatchStatistics from "./components/SoccerScoresMatchStatistics.vue";
import SoccerScoresLineups from "./components/SoccerScoresLineups.vue";
import SoccerScoresMatchTimeline from "./components/SoccerScoresMatchTimeline.vue";
import axios from "axios";

export default {
  name: "app",
  components: {
    SoccerScoresCompetitors,
    SoccerScoresConditions,
    SoccerScoresMatchStatus,
    SoccerScoresMatchStatistics,
    SoccerScoresMatchTimeline,
    SoccerScoresLineups,
  },
  data: function () {
    return {
      seasonYears: "",
      seasonYearId: "",
      competitions: "",
      competitionId: "",
      sportEvents: "",
      sportEventId: "",
      sportEvent: "",
      sport_event_conditions: "",
      sport_event_status: "",
      statistics: "",
      timeline: "",
      lineups: "",
      apiKey: "62xua64vk82qwkgzt8u2zrp6",
      competitorId1: "",
      competitorId2: "",
      competitorVsCompetitor: "",
      eventSelected: false,
      yearSelected: false,
      competitonSelected: false,
    };
  },
  created: async function () {
    try {
      const response = await axios.get(this.getCompetitionEndpoint(), {
        crossdomain: true,
      });
      this.competitions = response.data.competitions.sort(
        this.sortAlphabetically
      );
    } catch (err) {
      console.log("created: ", err);
    }
  },

  methods: {
    getCompetitionEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/competitions.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getCompetitionSeasonEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/competitions/${this.competitionId}/seasons.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getSeasoScheduleEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/seasons/${this.seasonYearId}/schedules.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getSportEventTimelineEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/sport_events/${this.sportEventId}/timeline.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getSportEventLineupsEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/sport_events/${this.sportEventId}/lineups.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    getCompetitorVsCompetitorEndpoint: function (showBetradarUrl = false) {
      let url = `https://kaxmatrix.com/oddsapi/soccer/production/v4/en/competitors/${this.competitorId1}/versus/${this.competitorId2}/summaries.json?api_key=${this.apiKey}`;

      if (showBetradarUrl) {
        url = url.replace(
          "https://kaxmatrix.com/oddsapi",
          "https://api.sportradar.us"
        );
      }

      return url;
    },

    selectCompetition: function (event) {
      this.competitionId = event.target.value;
      this.loadCompetitionSeasons();
    },

    selectSeasonYear: function (event) {
      this.seasonYearId = event.target.value;
      this.loadSportEvents();
    },

    selectSportEvent: function (event) {
      this.sportEventId = event.target.value;
      this.loadSingleSportEvent();
    },

    loadCompetitionSeasons: async function () {
      if (this.competitionId == "") return;
      try {
        const response = await axios.get(this.getCompetitionSeasonEndpoint(), {
          crossdomain: true,
        });
        this.seasonYears = response.data.seasons.sort(this.sortAlphabetically);
      } catch (err) {
        console.log("loadCompetitionSeasons: ", err);
      }
    },

    loadSportEvents: async function () {
      if (this.seasonYearId == "") return;
      try {
        const response = await axios.get(this.getSeasoScheduleEndpoint(), {
          crossdomain: true,
        });
        this.sportEvents = response.data.schedules.sort(this.sortByDate);
      } catch (err) {
        console.log("loadSportEvents: ", err);
      }
    },

    loadSingleSportEvent: async function () {
      if (this.sportEventId == "") return;
      try {
        const response = await axios.get(this.getSportEventTimelineEndpoint(), {
          crossdomain: true,
        });
        this.competitorId1 = response.data.sport_event.competitors[0].id;
        this.competitorId2 = response.data.sport_event.competitors[1].id;
        this.sportEvent = response.data.sport_event;
        this.sport_event_conditions =
          response.data.sport_event.sport_event_conditions;
        this.sport_event_status = response.data.sport_event_status;
        this.statistics = response.data.statistics;
        this.timeline = response.data.timeline;

        this.loadSportEventLineups();
        this.loadCompetitorVsCompetitor();
      } catch (err) {
        console.log("loadSingleSportEvent: ", err);
      }
    },

    loadSportEventLineups: async function () {
      if (this.sportEventId == "") return;
      try {
        const response = await axios.get(this.getSportEventLineupsEndpoint(), {
          crossdomain: true,
        });
        this.lineups = response.data.lineups.competitors;
      } catch (err) {
        console.log("loadSportEventLineups: ", err);
      }
    },

    loadCompetitorVsCompetitor: async function () {
      if (this.competitorId1 == "" || this.competitorId2 == "") return;
      try {
        const response = await axios.get(
          this.getCompetitorVsCompetitorEndpoint(),
          {
            crossdomain: true,
          }
        );
        this.competitorVsCompetitor = response.data;
      } catch (err) {
        console.log("loadCompetitorVsCompetitor: ", err);
      }
    },

    sortAlphabetically: function (a, b) {
      let nameA = a.name.toUpperCase();
      let nameB = b.name.toUpperCase();
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    },

    sortByDate: function (a, b) {
      let nameA = a.sport_event.start_time;
      let nameB = b.sport_event.start_time;
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      return 0;
    },

    getSportEventName: function (sportEvent) {
      let name = "";

      if (sportEvent.sport_event) {
        name += sportEvent.sport_event.start_time;
      }

      if (sportEvent.sport_event_status) {
        name += " - " + sportEvent.sport_event_status.status;
      }

      if (
        sportEvent.sport_event &&
        sportEvent.sport_event.competitors[0] &&
        sportEvent.sport_event.competitors[1]
      ) {
        name +=
          " - " +
          sportEvent.sport_event.competitors[0].name +
          " vs " +
          sportEvent.sport_event.competitors[1].name;
      }

      return name;
    },
  },
  computed: {},
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  color: #2c3e50;
  margin-top: 60px;
  font-size: 12px;
}

table {
  width: 100%;
}

.selection-tools {
  margin-bottom: 20px;
}

.selection-tools td,
.selection-tools th {
  background-color: #dedede;
}
</style>
